import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';

/**
 * Contador regressivo compartilhado entre a tela de verificação de celular
 * e o modal de troca de número. Reforça visualmente o cooldown com a cor de
 * erro (RF01) e reutiliza a mesma chave i18n nos dois lugares (RF04).
 *
 * `variant="body2"` (em vez de `caption`, a menor fonte da hierarquia do
 * MUI v4) + `fontWeight` mais forte: o motivo original do Bruno para pedir
 * essa mudança foi "a mensagem no canto da tela às vezes não é visível ao
 * usuário" - uma legenda pequena não resolveria o problema real reportado.
 */
const Countdown = ({ seconds }) => {
  const { t } = useTranslation();

  return (
    <Typography
      align="center"
      variant="body2"
      component="div"
      color="error"
      style={{ fontWeight: 600 }}
    >
      {t('You can request a new code in {{seconds}}s', { seconds })}
    </Typography>
  );
};

export default Countdown;
